import React, { useContext, useEffect, useState } from 'react'
import { Breadcrumb, ContentDropDown, Heading } from '../common/atoms'
import { UserAlert } from '../common/atoms/alerts'
import { UploadCard } from '../common/organisms'
import { AppStateContext, AppDispatchContext } from '../../utils/contexts'
import { DRAGGER_CONTENT, FAQS } from '../../constants/employeeData'
import { recentSearchSchema as tableschema } from '../../schemas/table'
import { Table } from '../common/molecules'
import employeeDataApi from '../../services/employee_data.api'
import handleAppError from '../handlers/handleAppError'
import {RECENT_UPLOADS_HEADERS as HEADERS} from '../../constants/tableHeaders'

const EmployeeRegistrationPage = ({ history }) => {
  const {employee_data : state} = useContext(AppStateContext)
  const dispatch = useContext(AppDispatchContext)
  const [recentUploads, setRecentUploads] = useState([])
  const [viewMoreFlag, setViewMoreFlag] = useState(false)
  const [entities, setEntities] = useState([])
  const uploadRequest = (info) => {
    dispatch({ type: 'employee_data', file: info.file })
    history.push('/employee-data/file-upload?of=employee_addition')
  }

  const fetchRecentUploads = async () => {
    try {
      let result = await employeeDataApi.fetch_recent_uploads({type: 'EmployeeRegistration'})
      let data = result.data.customer_data_uploads
      const entities = result.data.meta.entities || []
      setEntities(entities)
      dispatch({ type: 'employee_data', entities })
      setRecentUploads(data || [])
    } catch (err) {
      handleAppError(err)
    }
  }

  const viewRecentHandler = (id) => {
    history.push('/employee-data/view-result?of=employee_addition', {id})
  }

  useEffect(() => {
    if (state.pathId !== '0123') dispatch({ type: 'employee_data', file: null, tabledata: null, pathId: '0123' })
    if (state.click_dragger) {
      setTimeout(() => {
        const dragger = document.getElementById('dragger')
        dragger.click()
        dispatch({ type: 'toggle dragger click' })
      }, 0)
    }
    if(state.tabledata) dispatch({ type: '', showAddIcon: true })
    fetchRecentUploads()
  }, [])

  return (
    <React.Fragment>
      <Breadcrumb
        list={[
          { text: 'Manage Employees', link: '/employee-registration' },
          { text: 'Add Employee', link: '/employee-registration' },
        ]}
        classes='mb-1'
      />
      <Heading mainHeading='Add Employee' mainClasses='text-xl leading-5 text-gray-900 font-semibold' />
      {entities.length >= 1 && <UserAlert para='Entity name is mandatory field while adding employee through CSV' icon='yellow' classes='p-4 mt-6' paraClasses='leading-5 text-gray-700' /> }
      {state.tabledata && (
        <UserAlert
          icon='red'
          para='Your file has been processed. There are some validation error in the data.'
          btntext='View Error'
          btnHandler={() => history.push('/employee-data/view-errors?of=employee_addition')}
          classes='border border-red-600 py-3 px-4 mt-8'
          paraClasses='text-gray-700 leading-4 font-semibold '
        />
      )}
      <UploadCard CONTENT={DRAGGER_CONTENT['employee_register']} uploadRequest={uploadRequest} classes='mt-8'  listHeading={["Download CSV File", "Download XLSX File"]} />
      <p className='tracking-widest text-xs text-gray-500  font-semibold mb-3 mt-12'>RECENT ACTIVITY</p>
      <Table classes='rounded-lg' tableClasses='alternate_gray200_color' loading={false} loaderHeight={300} headers={HEADERS} data={viewMoreFlag ? recentUploads:recentUploads.slice(0, 3)} tableschema={tableschema} handler={viewRecentHandler}/>
      {recentUploads.length > 3  && <span className='text-base font-semibold text-blue-500 mt-4 block cursor-pointer' onClick={() => setViewMoreFlag(flag => !flag)}>VIEW {viewMoreFlag ? 'LESS':'MORE'}</span>}
      <div className='flex mt-12'>
        <div className='w-1/2'>
          <h1 className='text-lg font-semibold text-gray-700'>Frequently asked questions</h1>
          <p className='mb-0 mt-2 text-gray-600'>Can’t find the answer you’re looking for?</p>
          <p className='mb-0 text-gray-600'>
            Reach out to our <span className='font-semibold text-blue-500'>customer success manager.</span>
          </p>
        </div>
        <div className='w-1/2'>
          {FAQS['add'].map((item, ind) => {
            return <ContentDropDown key={item.title} {...item} classes={ind === 0 ? '' : 'mt-6'} />
          })}
        </div>
      </div>
    </React.Fragment>
  )
}

export default React.memo(EmployeeRegistrationPage)
